import AddStorePage from './AddStorePage'

export default AddStorePage
